(() => {
  'use strict';
  if (window.ppRedeemlyDrawer) return;
  window.ppRedeemlyDrawer = true;
  const rootId = 'mcb__rewards-on-cart-widget__root';
  let root = null;
  let loading = false;
  let failed = false;
  let wasOpen = false;
  let scheduled = false;
  let lastCount = 0;
  let runtimeReady = false;
  const originScript = document.currentScript;
  const nonce = originScript ? originScript.nonce : '';

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; sync(); });
  }

  function mount(slot) {
    if (root && root.parentElement !== slot) slot.appendChild(root);
    const hasReward = !!(root && root.querySelector('.mcb-cart-widget') && root.textContent.trim());
    const shouldHide = !hasReward || Number(slot.dataset.cartCount) < 1;
    if (slot.hidden !== shouldHide) slot.hidden = shouldHide;
  }

  async function initialise(slot) {
    loading = true;
    let createdRoot = false;
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 12000);
    try {
      const cartUrl = new URL(slot.dataset.cartUrl, location.origin);
      if (cartUrl.origin !== location.origin) throw new Error('Invalid cart origin');
      const response = await fetch(cartUrl.href, { credentials: 'same-origin', cache: 'no-store', signal: controller.signal });
      if (!response.ok) throw new Error('Cart unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const sourceRoot = doc.getElementById(rootId);
      const block = sourceRoot && sourceRoot.closest('.shopify-app-block');
      const init = block && Array.from(block.querySelectorAll('script:not([src])')).find(script => script.textContent.includes('window.mcb_cart_integration_context ='));
      const asset = Array.from(doc.querySelectorAll('script[src]')).find(script => {
        const url = new URL(script.getAttribute('src'), cartUrl);
        return url.protocol === 'https:' && url.hostname === 'cdn.shopify.com' && url.pathname.startsWith('/extensions/') && url.pathname.endsWith('/assets/rewards_on_cart_widget.js');
      });
      if (!sourceRoot || !init || !asset) throw new Error('Redeemly cart block missing');
      root = document.getElementById(rootId);
      if (!root) {
        root = document.createElement('div');
        root.id = rootId;
        createdRoot = true;
      }
      const currentSlot = document.querySelector('#CartDrawer [data-pp-redeemly]');
      if (!currentSlot) throw new Error('Drawer unavailable');
      currentSlot.appendChild(root);
      if (!window.mcb_cart_integration_context) {
        const setup = document.createElement('script');
        if (nonce) setup.nonce = nonce;
        setup.textContent = init.textContent;
        document.head.appendChild(setup);
        setup.remove();
      }
      if (!window.mcb_cart_integration_context) throw new Error('Redeemly context unavailable');
      if (!root.querySelector('.mcb-cart-widget') && !runtimeReady) {
        await new Promise((resolve, reject) => {
          const script = document.createElement('script');
          script.src = new URL(asset.getAttribute('src'), cartUrl).href;
          if (nonce) script.nonce = nonce;
          script.onload = () => { runtimeReady = true; resolve(); };
          script.onerror = () => { script.remove(); reject(new Error('Redeemly script unavailable')); };
          document.head.appendChild(script);
        });
      }
      failed = false;
    } catch (error) {
      failed = true;
      if (createdRoot && !runtimeReady && root) { root.remove(); root = null; }
      console.warn('[PottePlanten] Plantesaldo kunne ikke vises i kurven.', error.message);
    } finally {
      clearTimeout(timeout);
      loading = false;
      schedule();
    }
  }

  function sync() {
    const drawer = document.getElementById('CartDrawer');
    const slot = drawer && drawer.querySelector('[data-pp-redeemly]');
    if (!slot) return;
    const open = !drawer.hidden;
    const count = Number(slot.dataset.cartCount) || 0;
    if ((open && !wasOpen) || (count > 0 && lastCount === 0)) failed = false;
    wasOpen = open;
    lastCount = count;
    if (root) { mount(slot); return; }
    if (open && count > 0 && !loading && !failed) initialise(slot);
  }

  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['hidden', 'data-cart-count'] });
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  schedule();
})();
